const form = document.querySelector('#customer-account-form')
const successURL = form.getAttribute('data-success-url')
const actionURL = form.getAttribute('action')
const loader = document.querySelector('#account-form-loader')

const emailInput = document.getElementById("register-email");
const passwordInput = document.getElementById('register-password');
const phoneInput = document.getElementById("register-phone-national");
const countrySelect = document.getElementById('register-phone-country');

const newsletterToggle = document.getElementById('toggle-newsletter');
const marketingPreferencesSection = document.getElementById('marketing-preferences-section');
const smsToggle = document.getElementById('toggle-sms');
const customerClubToggle = document.getElementById('toggle-customerclub');

const editInfoButton = document.querySelector('[data-edit-info]');
const translations = window.theme.strings.customer.register.errors;

// Helper function to get UTM parameters from URL
function getUTMParameters() {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    utm_source: urlParams.get('utm_source') || '',
    utm_campaign: urlParams.get('utm_campaign') || '',
    utm_content: urlParams.get('utm_content') || ''
  };
}

editInfoButton?.addEventListener('click', () => {
  const profileView = document.querySelector('[data-profile]')
  const editProfileView = document.querySelector('[data-edit-profile]')

  profileView.hidden = true
  editProfileView.hidden = false

  // Initialize marketing preferences visibility on edit
  initializeMarketingPreferences()
  addMarketingPreferenceListeners()
})

phoneInput.addEventListener('change', () => {
  validatePhone(phoneInput, countrySelect);
})

emailInput.addEventListener('change', () => {
  validateEmail(emailInput);
})

passwordInput?.addEventListener('change', function() {
  validatePassword(passwordInput);
});

countrySelect.addEventListener('change', () => {
  if(phoneInput.value === '') return
  validatePhone(phoneInput, countrySelect);
})

// Newsletter toggle handler
newsletterToggle?.addEventListener('change', () => {
  toggleMarketingPreferences()
})

// Initialize marketing preferences on page load
function initializeMarketingPreferences() {
  if (newsletterToggle && newsletterToggle.checked) {
    showMarketingPreferences()
  }
}

// Toggle marketing preferences visibility
function toggleMarketingPreferences() {
  if (newsletterToggle.checked) {
    showMarketingPreferences()
    // Auto-select all preferences if none are currently selected
    const hasExistingPreferences = getSelectedMarketingPreferences().length > 0
    if (!hasExistingPreferences) {
      selectAllMarketingPreferences()
    }
  } else {
    hideMarketingPreferences()
    clearMarketingPreferences()
  }
}

function showMarketingPreferences() {
  if (marketingPreferencesSection) {
    marketingPreferencesSection.style.display = 'block'
  }
}

function hideMarketingPreferences() {
  if (marketingPreferencesSection) {
    marketingPreferencesSection.style.display = 'none'
  }
}

function clearMarketingPreferences() {
  const checkboxes = document.querySelectorAll('input[name="marketing_preferences"]')
  checkboxes.forEach(checkbox => {
    checkbox.checked = false
  })
}

function selectAllMarketingPreferences() {
  const checkboxes = document.querySelectorAll('input[name="marketing_preferences"]')
  checkboxes.forEach(checkbox => {
    checkbox.checked = true
  })
}

// Add event listeners to marketing preference checkboxes
function addMarketingPreferenceListeners() {
  const preferenceCheckboxes = document.querySelectorAll('input[name="marketing_preferences"]')
  preferenceCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', checkAndUpdateNewsletterState)
  })
}

// Initialize on page load
if (newsletterToggle) {
  initializeMarketingPreferences()
  addMarketingPreferenceListeners()
}

const validateCustomerClub = () => {
  if(customerClubToggle.checked) {
    let isValid = true

    // Check if newsletter is checked
    // if (!newsletterToggle.checked) {
    //   showError(newsletterToggle.closest('.customer-club__form__field--container'), translations.newsletter_required)
    //   isValid = false
    // } else {
    //   clearError(newsletterToggle.closest('.customer-club__form__field--container'))
    // }

    // Check if SMS is checked.
    // if (!smsToggle.checked) {
    //   showError(smsToggle.closest('.customer-club__form__field--container'), translations.sms_required)
    //   isValid = false
    // } else {
    //   clearError(smsToggle.closest('.customer-club__form__field--container'))
    // }

    // Validate that at least one marketing preference is selected for club members
    if (newsletterToggle.checked) {
      const selectedPreferences = getSelectedMarketingPreferences()
      if (selectedPreferences.length === 0) {
        showError(marketingPreferencesSection, translations.marketing_preferences_required || 'Please select at least one marketing preference')
        isValid = false
      } else {
        clearError(marketingPreferencesSection)
      }
    }

    return isValid
  } else {
    clearError(smsToggle.closest('.customer-club__form__field--container'))
    clearError(newsletterToggle.closest('.customer-club__form__field--container'))
    clearError(marketingPreferencesSection)
    return true
  }
}

const validateEmail = (input) => {
  const emailValue = input.value.trim();

  if (!emailValue) {
    showError(input, translations.email_required);
    return false
  } else if (!isValidEmail(emailValue)) {
    showError(input, translations.invalid_email);
    return false
  } else {
    clearError(input);
    return true
  }
}

const isValidEmail = (email) => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}

const validatePassword = (input) => {
  const passwordValue = input.value.trim();

  if (passwordValue.length < 6) {
    showError(input, translations.password);
    return false
  } else {
    clearError(input);
    return true
  }
}

const validatePhone = (input, countrySelect) => {
  const phoneValue = input.value.trim();
  const countryCode = countrySelect.selectedOptions[0].getAttribute('data-country');

  if(!window.libphonenumber) return showError(input, "Something went wrong");
  const { parsePhoneNumberFromString, isValidPhoneNumber } = window.libphonenumber

  if (phoneValue.startsWith('+')) {
    showError(phoneInput, translations.phone_countrycode);
    return false;
  }

  const phoneNumber = parsePhoneNumberFromString(phoneValue, countryCode);

  if (!phoneNumber) {
    showError(input, translations.invalid_phone);
    return false
  } else if (!isValidPhoneNumber(phoneValue, countryCode)) {
    showError(input, translations.invalid_phone_country);
    return false
  } else {
    clearError(input);
    return true
  }
}

const showError = (input, messages) => {
  let errorElement = input.nextElementSibling;
  if (!errorElement || !errorElement.classList.contains('error-message')) {
    errorElement = document.createElement('div');
    errorElement.className = 'error-message';
    input.parentNode.insertBefore(errorElement, input.nextSibling);
  }

  const messageHTML = Array.isArray(messages)
    ? `<p>${messages.join(' ')}</p>`
    : `<p>${messages}</p>`;

  errorElement.innerHTML = messageHTML;
  input.classList.add('error');
}

const clearError = (input) => {
  let errorElement = input.nextElementSibling;
  if (errorElement && errorElement.classList.contains('error-message')) {
    errorElement.remove();
  }
  input.classList.remove('error');
}

function createDummyRecaptchaForm(action, type) {
  const dummyRecaptchaForm = document.createElement('form');
  
  dummyRecaptchaForm.action = action;
  dummyRecaptchaForm.method = "post";
  dummyRecaptchaForm.id = `dtails-hidden-recaptcha-trigger__${type}`;
  dummyRecaptchaForm.setAttribute('aria-hidden', 'true');
  dummyRecaptchaForm.style.display = 'none';

  const formTypeInput = document.createElement('input');

  formTypeInput.name = "form_type"
  formTypeInput.setAttribute('value', type);

  dummyRecaptchaForm.appendChild(formTypeInput);

  return dummyRecaptchaForm;
}

function createLoginForm() {
  const form = createDummyRecaptchaForm('/account/login', 'customer_login');
  const email = document.createElement('input');
  email.name = 'customer[email]';

  const password = document.createElement('input');
  password.name = 'customer[password]';

  const redirect = document.createElement('input');
  redirect.name = 'return_to';

  form.appendChild(email);
  form.appendChild(password);
  form.appendChild(redirect);
  form.setAttribute('aria-hidden', 'true');

  return form;
}

function triggerFocusEvent(element) {
  const event = new Event('focusin', { bubbles: true, cancelable: false });
  element.dispatchEvent(event);
}

function triggerShopifyRecaptchaLoad(container) {
  const customerRecaptchaForm = createDummyRecaptchaForm('/account', 'create_customer');
  container.appendChild(customerRecaptchaForm);

  triggerFocusEvent(customerRecaptchaForm);
}

function injectHiddenForms() {
  const container = document.createElement('div');
  
  container.id = "dtails_hidden_forms";
  container.style.display = 'none';
  container.setAttribute('aria-hidden', 'true');

  document.body.appendChild(container);

  const loginForm = createLoginForm();
  
  container.appendChild(loginForm);

  if (window.Shopify.captcha) {
    triggerShopifyRecaptchaLoad(container);

    window.Shopify.captcha.protect(loginForm);
  }
}

// Helper function to get selected marketing preferences
function getSelectedMarketingPreferences() {
  const selectedCheckboxes = document.querySelectorAll('input[name="marketing_preferences"]:checked')
  return Array.from(selectedCheckboxes).map(checkbox => checkbox.value)
}

// Validate marketing preferences
function validateMarketingPreferences() {
  if (newsletterToggle && newsletterToggle.checked) {
    const selectedPreferences = getSelectedMarketingPreferences()
    if (selectedPreferences.length === 0) {
      showError(marketingPreferencesSection, translations.marketing_preferences_required || 'Please select at least one marketing preference')
      return false
    } else {
      clearError(marketingPreferencesSection)
      return true
    }
  }
  return true
}

// Check if all preferences are deselected and auto-uncheck newsletter
function checkAndUpdateNewsletterState() {
  if (newsletterToggle && newsletterToggle.checked) {
    const selectedPreferences = getSelectedMarketingPreferences()
    if (selectedPreferences.length === 0) {
      // Auto-uncheck newsletter and collapse section (but not during form submission)
      // This provides a smooth UX for interactive changes, but validation will catch submission issues
      newsletterToggle.checked = false
      hideMarketingPreferences()
      clearError(marketingPreferencesSection) // Clear any existing validation errors
    }
  }
}

if (passwordInput !== null) {
  injectHiddenForms();
}

form.addEventListener('submit', async (e) => {
  e.preventDefault();

  const register = passwordInput === null ? false : true
  let isFormValid = true;
  
  if (!validateCustomerClub()) isFormValid = false;
  if (!validateMarketingPreferences()) isFormValid = false;
  if (!validatePhone(phoneInput, countrySelect)) isFormValid = false;
  if (!validateEmail(emailInput)) isFormValid = false;

  if (register) {
    if (!validatePassword(passwordInput)) isFormValid = false;
  }

  if (!isFormValid) return false

  const formData = new FormData(form)
  loader.hidden = false;
  let customerData = {}

  if (register) {
    const formattedChildren = []
    const childForms = document.querySelectorAll('child-form form')
    for (let i = 0; i < childForms.length; i++) {
      const childForm = childForms[i];
      if(!childForm.checkValidity()) {
        return childForm.reportValidity();
      }
    }

    childForms.forEach(childForm => {
      const childFormData = new FormData(childForm)
      formattedChildren.push({
        first_name: childFormData.get(`child_name`).split(" ")[0],
        last_name: childFormData.get(`child_name`).split(" ").slice(1).join(' '),
        gender: childFormData.get(`child_gender`),
        relation: childFormData.get(`child_relation`),
        birthdate: childFormData.get(`child_birthdate`)
      })
    })

    customerData = {
      address: formData.get('address1'),
      city: formData.get('city'),
      zip: formData.get('zip'),
      password: formData.get('password'),
      phone: `+${formData.get('phone_country')}${formData.get('phone_national')}`,
      first_name: formData.get('first_name'),
      last_name: formData.get('last_name'),
      country: formData.get('country'),
      email: formData.get('email'),
      member: formData.has('clubstatus'),
      marketing_preferences: getSelectedMarketingPreferences(),
      sms: formData.has('sms'),
      children: formattedChildren,
      ...(formData.has('gender') ? { gender: formData.get('gender') } : {}),
      ...(formData.has('birthdate') && formData.get('birthdate') !== "" ? { birthdate: formData.get('birthdate') } : {}),
      ...(formData.has('store') ? { store: formData.get('store') } : {})
    }
  } else {
    customerData = {
      first_name: formData.get('first_name'),
      last_name: formData.get('last_name'),
      phone: `+${formData.get('phone_country')}${formData.get('phone_national')}`,
      email: formData.get('email'),
      member: formData.has('clubstatus'),
      marketing_preferences: getSelectedMarketingPreferences(),
      sms: formData.has('sms'),
      address: {
        address: formData.get('address1'),
        country: formData.get('country'),
        city: formData.get('city'),
        zip: formData.get('zip'),
      },
      ...(formData.has('gender') ? { gender: formData.get('gender') } : {}),
      ...(formData.has('birthdate') && formData.get('birthdate') !== "" ? { birthdate: formData.get('birthdate') } : {}),
      ...(formData.has('store') ? { store: formData.get('store') } : {})
    }
  }

  try {
    const response = await fetch(actionURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(customerData)
    });
  
    if (response.status === 422) {
      throw await response.json();
    }

    console.log("datalayer start");
  
    if (!response.ok) {
      throw new Error('Network response was not okay');
    }

    // Push event to dataLayer for Google Tag Manager tracking
    window.dataLayer = window.dataLayer || [];
    const utmParams = getUTMParameters();
    window.dataLayer.push({
      event: 'customer_club_signup',
      signup_type: register ? 'registration' : 'update',
      club_opt_in: customerClubToggle ? customerClubToggle.checked : false,
      utm_source: utmParams.utm_source,
      utm_campaign: utmParams.utm_campaign,
      utm_content: utmParams.utm_content
    });

    console.log("datalayer pushed successfully");
    console.log("datalayer", window.dataLayer);
  
    // Delay to ensure GTM processes the event before page navigation
    // Recommended: Also enable "Wait for tags" in GTM Form Submission trigger (1500-2000ms timeout)
    setTimeout(() => {
      if(register) {
        const hiddenLoginForm = document.getElementById('dtails-hidden-recaptcha-trigger__customer_login');
        hiddenLoginForm.querySelector('[name="customer[email]"]').value = customerData.email;
        hiddenLoginForm.querySelector('[name="customer[password]"]').value = customerData.password;

        if (successURL) {
          hiddenLoginForm.querySelector('[name="return_to"]').value = successURL;
        }

        hiddenLoginForm.submit();
      } else {
        window.location.reload();
      }
    }, 1500);
  } catch (error) {
    loader.hidden = true;
    if (error && typeof error === 'object' && error.errors) {
      if (error.errors.hasOwnProperty('phone')) {
        showError(phoneInput, translations.tel_exists);
      }
  
      if (error.errors.hasOwnProperty('email')) {
        showError(emailInput, [translations.email_exists, translations.recommendation]);
      }

      if (error.errors.hasOwnProperty('account')) {
        showError(emailInput, [translations.account_disabled]);
      }
  
      window.scrollTo({ top: 0, behavior: 'instant' });
    } else {
      console.error(error);
    }
  }
})

if (Shopify && Shopify.CountryProvinceSelector) {
  new Shopify.CountryProvinceSelector('register-country', 'register-province', {
    hideElement: 'province-container',
  });
}